import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { globalTheme } from './theme/globalTheme';
import BglLoader from './ui-components/BglLoader';
import FeesSimulator from './fees-simulator/FeesSimulator';

const App = ({store}) => (
    <Provider store={store}>
      <div className="App">
        <ThemeProvider theme={globalTheme}>
          <Suspense fallback={<BglLoader/>}>
                <FeesSimulator/>
          </Suspense>
        </ThemeProvider>
      </div>
    </Provider>
);

App.propTypes = {
  store: PropTypes.object.isRequired
};

export default App;
